import React from "react";
import { ACTIVE_RUN_STATES, costPresentation, durationLabel } from "./helpers.mjs";
import { taskKey } from "./platform-tasks.mjs";
import { taskLaunchNumberLabel } from "./task-launch-number.jsx";
import { taskSolutionName, taskSolutionVersion } from "./solution-version.mjs";

export function TaskTable({ tasks, solutions, onSelect, canViewFinance, StateBadge, formatDate, label }) {
  const showOrganization = tasks.some((task) => task.organizationName);
  return <div className="table-wrap task-table-wrap" role="region" aria-label={label} tabIndex={0}>
    <table className="task-table">
      <thead><tr>
        <th scope="col">Запуск</th>
        <th scope="col">Компания / ИНН</th>
        <th scope="col">Решение</th>
        <th scope="col">Версия</th>
        {showOrganization && <th scope="col">Организация</th>}
        <th scope="col">Дата</th>
        <th scope="col">Время</th>
        {canViewFinance && <th scope="col" className="task-table-cost">Расходы</th>}
        <th scope="col">Состояние</th>
      </tr></thead>
      <tbody>{tasks.map((task) => {
        const solution = solutions.find((item) => item.solutionId === task.solutionId);
        const number = taskLaunchNumberLabel(task);
        const company = task.subject?.companyName;
        const inn = task.subject?.inn;
        const subject = company ? `${company}${inn ? ` · ${inn}` : ""}` : inn || task.title || "Задача";
        const solutionName = taskSolutionName(task, solution);
        const version = taskSolutionVersion(task);
        const cost = canViewFinance ? costPresentation(task.cost?.executionCost || task.cost || {}, ACTIVE_RUN_STATES.has(task.status)) : null;
        const elapsed = task.createdAt ? durationLabel(new Date(task.completedAt || Date.now()) - new Date(task.createdAt)) : "—";
        const open = () => onSelect(task.taskId, task);
        const openLabel = number ? `Открыть запуск ${number}` : "Открыть запуск";
        return <tr key={taskKey(task)}>
          <td className="task-table-number"><button type="button" className="text-link task-table-open" onClick={open} aria-label={openLabel} title={task.title}>{number || "—"}</button></td>
          <td className="task-table-subject"><div className="task-table-subject-content"><button type="button" className="text-link task-table-open" onClick={open} aria-label={`${subject}. ${openLabel}`} title={company ? subject : task.title || subject}>{subject}</button>{task.cacheHit && <span className="task-table-cache" title={`Сохранённый результат от ${formatDate(task.cacheSourceDate)}. Новых вызовов нет.`}>Из архива</span>}</div></td>
          <td className="task-table-solution" title={solutionName}>{solutionName}</td>
          <td className="task-table-version" title={version ? `Версия решения ${version}` : "Версия решения не указана"}>{version || "—"}</td>
          {showOrganization && <td className="task-table-organization" title={task.organizationName}>{task.organizationName || "—"}</td>}
          <td className="task-table-date">{task.createdAt ? <time dateTime={task.createdAt}>{formatDate(task.createdAt)}</time> : "—"}</td>
          <td className="task-table-duration">{elapsed}</td>
          {cost && <td className="task-table-cost" title={cost.note}>{cost.value}</td>}
          <td className="task-table-state"><StateBadge state={task.status}/></td>
        </tr>;
      })}</tbody>
    </table>
  </div>;
}
